import { InputNumber, InputNumberChangeEvent } from "primereact/inputnumber";
import React from "react";
import { T } from "services/lang/LanguageService";
import { PeriodicDataChartProps } from "../PeriodicDataChartTypes";

interface MarginEditorProps {
  currentConfig: PeriodicDataChartProps;
  setCurrentConfig: (currentConfig: PeriodicDataChartProps) => void;
}

enum MarginTarget {
  TOP = "t",
  BOTTOM = "b",
  LEFT = "l",
  RIGHT = "r",
}

const MarginEditor = ({ currentConfig, setCurrentConfig }: MarginEditorProps) => {
  const handleMarginChange = (e: InputNumberChangeEvent, target: MarginTarget) => {
    setCurrentConfig({
      ...currentConfig,
      chartMargin: { ...currentConfig.chartMargin, [target]: e.value ?? 0 },
    });
  };

  return (
    <div className="flex flex-row justify-content-between">
      <div className="flex flex-row gap-4">
        <div className="flex flex-column gap-2">
          <label htmlFor="marginTop">{T("layout.top-margin")}</label>
          <InputNumber
            id="marginTop"
            value={currentConfig.chartMargin?.t ?? 0}
            onChange={e => handleMarginChange(e, MarginTarget.TOP)}
            suffix="px"
          />
        </div>
        <div className="flex flex-column gap-2">
          <label htmlFor="marginBottom">{T("layout.bottom-margin")}</label>
          <InputNumber
            id="marginBottom"
            value={currentConfig.chartMargin?.b ?? 0}
            onChange={e => handleMarginChange(e, MarginTarget.BOTTOM)}
            suffix="px"
          />
        </div>
        <div className="flex flex-column gap-2">
          <label htmlFor="marginLeft">{T("layout.left-margin")}</label>
          <InputNumber
            id="marginLeft"
            value={currentConfig.chartMargin?.l ?? 0}
            onChange={e => handleMarginChange(e, MarginTarget.LEFT)}
            suffix="px"
          />
        </div>
        <div className="flex flex-column gap-2">
          <label htmlFor="marginRight">{T("layout.right-margin")}</label>
          <InputNumber
            id="marginRight"
            value={currentConfig.chartMargin?.r ?? 0}
            onChange={e => handleMarginChange(e, MarginTarget.RIGHT)}
            suffix="px"
          />
        </div>
      </div>
    </div>
  );
};

export default MarginEditor;
